import moment from 'moment';
import { getAuthorInitials } from '../../../../helpers/orderNotes';

export const ACTOR_TYPE_SYSTEM = 'system';

const TIME_GROUP_ORDER = ['Today', 'Yesterday', 'Last week', 'Last month', 'Older'];

export const getActivityTimeGroup = createdAt => {
  const entry = moment(createdAt);
  const now = moment();

  if (entry.isSame(now, 'day')) return 'Today';
  if (entry.isSame(now.clone().subtract(1, 'day'), 'day')) return 'Yesterday';
  if (entry.isAfter(now.clone().subtract(7, 'days').startOf('day'))) return 'Last week';
  if (entry.isAfter(now.clone().subtract(1, 'month').startOf('day'))) return 'Last month';
  return 'Older';
};

export const groupActivityItems = (items = []) => {
  const grouped = items.reduce((acc, item) => {
    const label = getActivityTimeGroup(item.createdAt);
    if (!acc[label]) acc[label] = [];
    acc[label].push(item);
    return acc;
  }, {});

  return TIME_GROUP_ORDER.filter(label => grouped[label]?.length).map(label => ({
    label,
    items: grouped[label]
  }));
};

const isCurrentUser = (actor, currentUser) => {
  if (!actor || !currentUser) return false;
  const actorUserId = actor.userId?.toString?.() || String(actor.userId || '');
  const currentUserId = currentUser._id?.toString?.() || String(currentUser._id || '');
  if (actorUserId && currentUserId && actorUserId === currentUserId) return true;

  const actorEmail = String(actor.email || '').trim().toLowerCase();
  const currentEmail = String(currentUser.email || '').trim().toLowerCase();
  return Boolean(actorEmail && currentEmail && actorEmail === currentEmail);
};

export const getActorLabel = (actor, currentUser) => {
  if (!actor) return 'Someone';
  if (actor.type === ACTOR_TYPE_SYSTEM) return 'System';
  if (isCurrentUser(actor, currentUser)) return 'You';
  return actor.name || actor.email || 'Someone';
};

export const formatActivityTimestamp = createdAt => moment(createdAt).format('h:mm A MMM D');

const COMPANION_EVENT_WINDOW_MS = 2000;

const isWithinWindow = (left, right) =>
  Math.abs(new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime()) <=
  COMPANION_EVENT_WINDOW_MS;

export const collapseCompanionActivityEvents = (items = []) => {
  const serviceCreates = items.filter(item => item.action === 'service.created');

  return items.filter(item => {
    if (item.action === 'order.created') {
      return !serviceCreates.some(serviceItem => isWithinWindow(item, serviceItem));
    }

    return true;
  });
};

export const getActorInitials = (actor, currentUser) => {
  if (!actor || actor.type === ACTOR_TYPE_SYSTEM) return null;
  if (isCurrentUser(actor, currentUser)) {
    return getAuthorInitials(currentUser?.name || currentUser?.email || 'You');
  }
  return getAuthorInitials(actor.name || actor.email || '?');
};
